import API from "../Common/Endpoint/serviceConstrants";
import axiosInstance from '../Common/Axios/axiosInstanceClient'
export const bannerMasterApi = async () => {
  const { data = {} } = await axiosInstance.get(API.getbannerMaster);
  return data;
};
